import Switch from "@mui/material/Switch";
import React, { useState, useEffect } from "react";
import styles from "./styles";

export interface IProps {
  id: string;
  value?: boolean;
  label: string;
  onChange?(id: string, checked: boolean): void;
  disabled?: boolean;
}

const InputSwitch: React.FC<IProps> = ({
  id,
  value = false,
  label,
  onChange,
  disabled = false,
}) => {
  const [checked, setChecked] = useState<boolean>(value);

  useEffect(() => {
    setChecked(value);
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    setChecked(isChecked);
    if (onChange) {
      onChange(id, isChecked);
    }
  };

  return (
    <>
      <Switch
        disabled={disabled}
        checked={checked}
        sx={styles}
        onChange={handleChange}
        value={checked}
        inputProps={{ "aria-label": label }}
        classes={{
          root: "rootSwitch",
          track: "track",
          thumb: "thumb",
          checked: "checked",
          switchBase: "switchBase",
        }}
      />
      {label && <span>{label}</span>}
    </>
  );
};

export default InputSwitch;
